import { render, staticRenderFns } from "./SignUpPageLanding.vue?vue&type=template&id=666cc16e"
import script from "./SignUpPageLanding.vue?vue&type=script&lang=js"
export * from "./SignUpPageLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports